import React, { useEffect, useState } from 'react'
import { Titles } from '../../constant/PageTitle'
import { Button, Card, Descriptions, Image, Input, Pagination, DatePicker, Select, Space, Spin, Table, Tag, Switch, Empty, Divider, Tooltip, } from 'antd'
import '../../style/page.css'
import { Edit, LinkIcon, SearchIcon, } from 'lucide-react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { editDaycareStatus, getDaycare, setDateKeyFilter, setPagination, setSearchParams } from '../../feature/dayCare/dayCareSlice';
import DefaultImage from '../../assets/png/defaultImgIcon.jpg'
import { dayCareDate, getTransactionStatus } from '../../constant/Constatnt';
import { actionResendPaymentLink } from '../../feature/dayCare/paymentHistorySlice';


function DayCareList() {
    const [loadingId, setLoadingId] = useState(null);
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [expandedRowKey, setExpandedRowKey] = useState(null);
    const [value, setValue] = useState("")
    const [daycareId, setDaycareId] = useState(null);
    const { daycareList, isLoading, actionLoader, date, totalPage, limit, current, searchParams } = useSelector((state) => state.daycares);
    const [dateType, setDateType] = useState("startDateFrom")

    const columns = [
        {
            title: 'Daycare Logo',
            dataIndex: 'daycareProfile',
            key: 'daycareProfile',
            ellipsis: true,
            render: (daycareProfile) => <Image src={daycareProfile} width={40} height={40} />
        },
        {
            title: 'Daycare Name',
            dataIndex: 'daycareName',
            key: 'daycareName',
            ellipsis: true,
            render: (text) => text?.length > 24 ? `${text.slice(0, 24)}...` : text,
        },
        {
            title: 'Currency',
            dataIndex: 'currency',
            key: 'currency',
            ellipsis: true,
            render: (currency) => <p> <strong>{currency?.symbol} </strong>({currency?.code})</p>,
        },
        {
            title: 'Subscription Plan',
            dataIndex: 'subScriptionPlanName',
            key: 'subScriptionPlanName',
            ellipsis: true,
        },


        {
            title: 'Email',
            dataIndex: 'ownerEmail',
            key: 'ownerEmail',
            ellipsis: true,
        },
        {
            title: 'Payment Status',
            dataIndex: 'paymentStatus',
            key: 'paymentStatus',
            ellipsis: true,
            render: (_, { paymentStatus, _id }) => <Tag color={getTransactionStatus(paymentStatus)}>{paymentStatus || "N/A"}</Tag>
        },

        {
            title: 'Start Date',
            dataIndex: 'startDate',
            key: 'startDate',
            ellipsis: true,
        },
        {
            title: 'Expiry Date ',
            dataIndex: 'expiryDate',
            key: 'expiryDate',
            ellipsis: true,
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            ellipsis: true,
            render: (_, { status, _id }) => <Switch
                checkedChildren="Active"
                unCheckedChildren="Inactive"
                checked={status === "ACTIVE"}
                loading={loadingId === _id}
                onChange={() => handleActive(_id)}
            />
        },
        {
            title: 'Action',
            ellipsis: true,
            fixed: "right",
            key: 'action',
            render: (_, {
                _id, status,paymentStatus

            }) => (
                <Space size="middle">
                    <Edit size={20} onClick={() => navigate(`/dashboard/edit-daycare/${_id}`)} />
                    <Tooltip title="Resend Payment Link" >
                        <Button disabled={paymentStatus ==="completed"} type='text' onClick={() => handleResentLink(_id)} icon={<LinkIcon />}></Button>
                    </Tooltip>
                </Space>
            ),
        },
    ];

    const handleActive = async (id) => {
        setLoadingId(id)
        const resultAction = await dispatch(editDaycareStatus({ daycareId: id }));
        if (editDaycareStatus.fulfilled.match(resultAction)) {
            await dispatch(getDaycare({}));
            setLoadingId(null);

        } else {
            console.error("edit status");
            setLoadingId(null);

        }
    };


    const handlePagination = (page) => {
        dispatch(setPagination(page))
    };

    const fetchDaycare = async () => {
        dispatch(getDaycare({ current, limit, searchParams, startDate: dateType === "startDateFrom" ? date : "", expireDate: dateType != "startDateFrom" ? date : "" }));
    }

    useEffect(() => {
        fetchDaycare()
    }, [current, searchParams, date, dateType])


    const onExpand = (expanded, record) => {
        console.log("expanded", expanded)
        const newExpandedRowKey = expandedRowKey === record.key ? null : record.key;
        setExpandedRowKey(newExpandedRowKey);
        if (expanded == false) {
            setExpandedRowKey(!newExpandedRowKey);
        }
        setDaycareId(record._id);
        console.log("click expend", record);
    };

    useEffect(() => {
        const timer = setTimeout(() => {
            dispatch(setSearchParams(value));
        }, 1000);

        return () => clearTimeout(timer);
    }, [value]);

    function handleSearch(e) {
        setValue(e.target.value);
    }

    const handleDate = (date, dateString) => {
        dispatch(setDateKeyFilter(dateString))
    }

    const handleDateKey = (value) => {
        setDateType(value)
    }

    const isPdf = (url) => {
        return url?.split("?")[0].toLowerCase().endsWith(".pdf");
    };

    const handleResentLink = async (id) => {
        const resultAction = await dispatch(actionResendPaymentLink({ daycareId: id }));
        if (actionResendPaymentLink.fulfilled.match(resultAction)) {
            await dispatch(getDaycare({}));
        } else {
            console.error("edit status");
        }
    };


    return (
        <section>
            <Card>
                <div className="page_title ">
                    <p>{Titles.daycare}</p>
                    <Space>
                        <Space.Compact>
                            <Select onChange={handleDateKey} defaultValue="startDateFrom" variant="filled" options={dayCareDate} />
                            <DatePicker onChange={handleDate} placeholder='Select Date' format="DD-MM-YYYY" variant="filled" style={{ width: "180px" }} />
                        </Space.Compact>
                        <Input allowClear size='large' suffix={<SearchIcon color='lightGray' size={16} />} placeholder="Search" onChange={handleSearch} variant="filled" />
                        {/* <AddConsultation fetchConsultationList={fetchConsultationList} /> */}
                        <div className="add_modal">
                            <Button type='primary' onClick={() => navigate('/dashboard/add-daycare')}>Add</Button>
                        </div>
                    </Space>
                </div>
            </Card>
            <div className="page_content">
                {isLoading ? <Spin fullscreen /> :
                    <Table
                        columns={columns}
                        rowKey={(record) => record._id}
                        scroll={{ x: true }}
                        id="sevice_table"
                        dataSource={daycareList}
                        pagination={false}
                        footer={() => (
                            <div className="pagination">
                                <Pagination
                                    current={current}
                                    onChange={handlePagination}
                                    total={totalPage ? totalPage * 10 : 0}
                                />
                            </div>
                        )}
                        expandable={{
                            expandedRowKeys: [expandedRowKey == null ? daycareId : expandedRowKey],
                            onExpand: onExpand,
                            expandedRowRender: (record) => (
                                <div className="consultation_details">
                                    <Divider orientation='center'>Daycare Details</Divider>
                                    <Descriptions >
                                        <Descriptions.Item label="Daycare Name">
                                            {record.daycareName}
                                        </Descriptions.Item>

                                        <Descriptions.Item label="Location Name">
                                            {record.locationName}
                                        </Descriptions.Item>
                                        <Descriptions.Item label="Start Date">
                                            {record.startDate}
                                        </Descriptions.Item>
                                        <Descriptions.Item label="Expiry Date">
                                            {record.expiryDate}
                                        </Descriptions.Item>
                                        <Descriptions.Item label="subScription Plan Name">
                                            {record.subScriptionPlanName}
                                        </Descriptions.Item>
                                        <Descriptions.Item label="Owner Phone">
                                            {record.ownerPhone}
                                        </Descriptions.Item>

                                        <Descriptions.Item label="Owner Password">
                                            {record.ownerPassword}
                                        </Descriptions.Item>
                                        <Descriptions.Item label="Owner Email">
                                            {record.ownerEmail}
                                        </Descriptions.Item>

                                        <Descriptions.Item label="Numbers Of Teachers">
                                            {record.numbersOfTeachers}
                                        </Descriptions.Item>

                                        <Descriptions.Item label="Numbers Of Admins">
                                            {record.numbersOfAdmins}
                                        </Descriptions.Item>

                                        <Descriptions.Item label="Number Of Students">
                                            {record.numberOfStudents}
                                        </Descriptions.Item>
                                        <Descriptions.Item label="Created At">
                                            {record.addedDate}
                                        </Descriptions.Item>
                                        {/* <Descriptions.Item span={3} label="Points">
                                        <ul>
                                            <p className='consultation_points'>{record.points?.map((item) => <li>{item}</li>)}</p>
                                        </ul>
                                    </Descriptions.Item> */}
                                        <Descriptions.Item span={3} label="Notes">
                                            {record.notes}
                                        </Descriptions.Item>
                                    </Descriptions>
                                    <Divider orientation='center'>Document</Divider>
                                    {
                                        record.licenses.length === 0 ? (
                                            <Empty />
                                        ) : (
                                            <Descriptions>
                                                {record.licenses.map((item, index) => (
                                                    <Descriptions.Item
                                                        key={index}
                                                        label={`Document ${index + 1}`}
                                                    >
                                                        <Space direction="vertical">
                                                            <h4>{item.documentName}</h4>

                                                            {isPdf(item.documentImage) ? (
                                                                <a
                                                                    href={item.documentImage}
                                                                    target="_blank"
                                                                    rel="noopener noreferrer"
                                                                    style={{ color: "#1890ff" }}
                                                                >
                                                                    View PDF
                                                                </a>
                                                            ) : (
                                                                <Image
                                                                    alt="documentImage"
                                                                    src={item.documentImage}
                                                                    width={40}
                                                                    height={40}
                                                                    fallback={DefaultImage}
                                                                />
                                                            )}
                                                        </Space>
                                                    </Descriptions.Item>
                                                ))}
                                            </Descriptions>
                                        )
                                    }
                                    {/* <Divider orientation='center'>Bank Details</Divider>
                                    {record.bankDetails ?
                                        <Descriptions>

                                            <Descriptions.Item label="Account Holder Name">
                                                {record.bankDetails.accountHolderName}
                                            </Descriptions.Item>
                                            <Descriptions.Item label="Bank Name">
                                                {record.bankDetails.bankName}
                                            </Descriptions.Item>
                                            <Descriptions.Item label="Account Number">
                                                {record.bankDetails.accountNumber}
                                            </Descriptions.Item>
                                            <Descriptions.Item label="IFSC Code">
                                                {record.bankDetails.ifscCode}
                                            </Descriptions.Item>
                                            <Descriptions.Item label="Branch Name">
                                                {record.bankDetails.branchName}
                                            </Descriptions.Item>
                                        </Descriptions>
                                        : <Empty />} */}

                                </div>
                            ),
                        }}
                    />}
            </div>
        </section >
    )
}






export default DayCareList